<ion-row>
  <ion-col size="12">
    <ion-row *ngIf="valgtTimeAnlegg" class="nokkeltall-grid">
      <ion-col size="12">
        <ion-row class="row-m">
          <ion-col class="box-col-nokkeltall">
            <div *ngIf="!showLoader; else loadingTemplate" class="flexx">
              <p>Forbruk</p>
              <div class="flex-end">
                <p
                  class="nokkeltall"
                  [class.produksjon-text]="totaltForbruk < 0"
                >
                  {{ toRoundNumber(totaltForbruk) }} kWh
                </p>
                <p *ngIf="isPlusskunde">netto etter prod.</p>
              </div>
            </div>
          </ion-col>
          <ion-col class="box-col-nokkeltall">
            <div *ngIf="!showLoader; else loadingTemplate">
              <p>
                Estimert kostnad
                <ion-icon
                  *ngIf="
                    selectedDate.getMonth() === currentDate.getMonth() &&
                    selectedDate.getFullYear() === currentDate.getFullYear()
                  "
                  name="help-circle-outline"
                  (click)="expandTooltip()"
                ></ion-icon>
              </p>
              <p class="nokkeltall" [class.produksjon-text]="totaltBelop < 0">
                {{ toRoundNumber(totaltBelop) }} kr
              </p>
              <p *ngIf="isPlusskunde">netto etter inntekt</p>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            class="box-col-nokkeltall mt-3 flex flex-row justify-around"
            *ngIf="isPlusskunde"
          >
            <div
              *ngIf="!showLoader; else loadingTemplate"
              class="flex flex-col"
            >
              <p>Produksjon</p>
              <div class="flex-end">
                <p class="nokkeltall">{{ toRoundNumber(produksjon) }} kWh</p>
              </div>
            </div>
            <div
              *ngIf="!showLoader; else loadingTemplate"
              class="flex flex-col"
            >
              <p>Inntekter</p>
              <div class="flex-end">
                <p class="nokkeltall">{{ toRoundNumber(inntekt) }} kr</p>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<ng-template #loadingTemplate>
  <div class="loadingContainer" *ngIf="showLoader">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
